<template>
    <!-- Main Modal -->
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xl" @click.stop>

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-arrow-left-right-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p v-if="Items.docnum" class="cf-modal-head__sub">Document N° {{ Items.docnum }}</p>
                                <p v-else class="cf-modal-head__sub">Mouvement de stock</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- ========== ALERTS ========== -->
                    <div v-if="messagesucces || messageerror" class="cf-alert-zone">
                        <Transition name="modal-fade">
                            <div v-if="messagesucces" class="cf-alert cf-alert--success">
                                <i class="ri-checkbox-circle-line"></i><span>{{ messagesucces }}</span>
                            </div>
                        </Transition>
                        <Transition name="modal-fade">
                            <div v-if="messageerror" class="cf-alert cf-alert--danger">
                                <i class="ri-error-warning-line"></i><span>{{ messageerror }}</span>
                            </div>
                        </Transition>
                    </div>

                    <!-- ========== CONTENT ========== -->
                    <div class="cf-dialog-body">

                        <!-- HEADER VIEW -->
                        <div v-show="!isdisplayviewarticle" class="space-y-4">
                            <!-- Info Banner -->
                            <div class="cf-info-banner">
                                <i class="ri-calendar-line"></i>
                                <span>Date : {{ Items.datedoc }}</span>
                            </div>

                            <!-- Magasin (simple) -->
                            <div v-if="typedoc !== 'mvt_transfert'" class="cf-field">
                                <label class="cf-field-label">Magasin / Dépôt / Entrepôt <span class="cf-req">*</span></label>
                                <div class="cf-select-wrap">
                                    <select v-model="Items.mag" class="cf-inp cf-select">
                                        <option :value="null">Sélectionner un entrepôt</option>
                                        <option v-for="(magasin, index) in returnGetAllmagasin" :key="index" :value="magasin">{{ magasin.name }}</option>
                                    </select>
                                    <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                </div>
                            </div>

                            <!-- Transfert : source + destination -->
                            <div v-else class="grid lg:grid-cols-2 gap-4">
                                <div class="cf-field">
                                    <label class="cf-field-label">Magasin source <span class="cf-req">*</span></label>
                                    <div class="cf-select-wrap">
                                        <select v-model="Items.mag" class="cf-inp cf-select">
                                            <option :value="null">Sélectionner un entrepôt</option>
                                            <option v-for="(magasin, index) in returnGetAllmagasin" :key="index" :value="magasin">{{ magasin.name }}</option>
                                        </select>
                                        <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                    </div>
                                </div>
                                <div class="cf-field">
                                    <label class="cf-field-label">Magasin destination <span class="cf-req">*</span></label>
                                    <div class="cf-select-wrap">
                                        <select v-model="Items.jsonotherdonne.magvers" class="cf-inp cf-select">
                                            <option :value="null">Vers l'entrepôt</option>
                                            <option v-for="(versmagasin, index) in listeversmagasins" :key="index" :value="versmagasin">{{ versmagasin.name }}</option>
                                        </select>
                                        <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- Motif / Raison -->
                            <div class="cf-field">
                                <label class="cf-field-label">Motif / Raison <span class="cf-req">*</span></label>
                                <textarea v-model="Items.docobservation" rows="3" class="cf-inp cf-textarea" placeholder="Saisissez le motif ou la raison du document..."></textarea>
                            </div>

                            <!-- Paramètre d'indication -->
                            <div class="cf-field">
                                <label class="cf-field-label">Paramètre d'indication</label>
                                <div class="cf-select-wrap">
                                    <select v-model="Items.params.param1" class="cf-inp cf-select">
                                        <option :value="null">Sélectionner un paramètre</option>
                                        <option v-for="(param, index) in alldata.paramcom" :key="index" :value="param">{{ param.name }}</option>
                                    </select>
                                    <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                </div>
                            </div>
                        </div>

                        <!-- ARTICLES VIEW -->
                        <div v-show="isdisplayviewarticle">
                            <!-- Article Form -->
                            <div class="cf-subpanel">
                                <div class="grid grid-cols-1 lg:grid-cols-12 gap-3">
                                    <!-- Article Selection -->
                                    <div class="lg:col-span-6 cf-field">
                                        <label class="cf-field-label">Article</label>
                                        <div class="flex gap-2">
                                            <input :value="ItemsArticle.article?.libelle || ''" placeholder="Sélectionner un article" type="text" disabled class="cf-inp cf-inp--readonly flex-1">
                                            <button @click="btnmodallistedesarticles('vente')" :disabled="disabled || isLoadingCatalogue" class="ti-btn ti-btn-primary-full" :class="{ 'opacity-50 cursor-not-allowed': disabled || isLoadingCatalogue }">
                                                <i class="ri-search-line align-middle"></i><span class="hidden sm:inline"> {{ isLoadingCatalogue ? 'Chargement des articles...' : 'Rechercher' }}</span>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Stock disponible -->
                                    <div class="lg:col-span-3 cf-field">
                                        <label class="cf-field-label">Stock disponible</label>
                                        <input :value="stock" type="text" disabled class="cf-inp cf-inp--readonly text-right">
                                    </div>

                                    <!-- Quantité -->
                                    <div class="lg:col-span-3 cf-field">
                                        <label class="cf-field-label">Quantité <span class="cf-req">*</span></label>
                                        <input v-model.number="ItemsArticle.qtite" type="number" min="0" step="0.01" class="cf-inp text-right">
                                    </div>
                                </div>

                                <!-- Action Buttons -->
                                <div class="flex flex-wrap gap-2 mt-4 pt-3 cf-subpanel-actions">
                                    <button @click="newArticle" class="ti-btn ti-btn-light"><i class="ri-add-line align-middle"></i> Nouveau</button>
                                    <button @click="SaveArticle" class="ti-btn ti-btn-success-full"><i class="ri-check-line align-middle"></i> Enregistrer</button>
                                    <button @click="deleteItemArticle" class="ti-btn ti-btn-danger-full"><i class="ri-delete-bin-line align-middle"></i> Supprimer</button>
                                </div>
                            </div>

                            <!-- Articles Table -->
                            <div class="cf-table-wrap mt-3">
                                <!-- Desktop Table -->
                                <table class="cf-table hidden lg:table">
                                    <thead>
                                        <tr>
                                            <th class="th" style="width:4rem">N°</th>
                                            <th class="th">Désignation</th>
                                            <th class="th th--right" style="width:8rem">Quantité</th>
                                            <th class="th th--center" style="width:6rem">État</th>
                                            <th class="th th--center" style="width:9rem">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="listedatatable.length">
                                            <template v-for="(datavalue, index) in listedatatable" :key="datavalue.linekey || index">
                                                <tr class="table-row">
                                                    <td class="td row-number">{{ index + 1 }}</td>
                                                    <td class="td">{{ datavalue.article?.libelle }}</td>
                                                    <td class="td td--right">{{ formatNumber(datavalue.qtite) }}</td>
                                                    <td class="td td--center">
                                                        <span class="cf-badge" :class="getStatusClass(datavalue.etatline)">
                                                            <span class="cf-badge-dot" :class="getStatusDotClass(datavalue.etatline)"></span>
                                                            {{ getStatusLabel(datavalue.etatline) }}
                                                        </span>
                                                    </td>
                                                    <td class="td td--center">
                                                        <button @click="modifierArticle(datavalue)" class="ti-btn ti-btn-primary-full ti-btn-sm"><i class="ri-check-line align-middle"></i> Sélectionner</button>
                                                    </td>
                                                </tr>
                                                <!-- Error Message Row -->
                                                <tr v-if="datavalue.etatline === 2 && datavalue.linemessage">
                                                    <td colspan="5" class="td cf-line-error"><span v-html="datavalue.linemessage"></span></td>
                                                </tr>
                                            </template>
                                        </template>
                                        <tr v-else>
                                            <td colspan="5" class="td">
                                                <div class="empty-state">
                                                    <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                                                    <p class="empty-state__title">Aucun article ajouté</p>
                                                    <p class="empty-state__sub">Utilisez le formulaire ci-dessus pour ajouter des articles</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- Mobile Cards -->
                                <div class="lg:hidden space-y-3">
                                    <template v-if="listedatatable.length">
                                        <div v-for="(datavalue, index) in listedatatable" :key="datavalue.linekey || index" class="cf-card">
                                            <div class="cf-card-head">
                                                <span class="cf-card-index">#{{ index + 1 }}</span>
                                                <span class="cf-badge" :class="getStatusClass(datavalue.etatline)">
                                                    <span class="cf-badge-dot" :class="getStatusDotClass(datavalue.etatline)"></span>
                                                    {{ getStatusLabel(datavalue.etatline) }}
                                                </span>
                                            </div>
                                            <div class="cf-card-body">
                                                <p class="cf-card-title">{{ datavalue.article?.libelle }}</p>
                                                <div class="grid grid-cols-2 gap-3">
                                                    <div>
                                                        <p class="cf-card-lbl">Quantité</p>
                                                        <p class="cf-card-val">{{ formatNumber(datavalue.qtite) }}</p>
                                                    </div>
                                                    <div class="text-right">
                                                        <p class="cf-card-lbl">Action</p>
                                                        <button @click="modifierArticle(datavalue)" class="cf-card-link">Sélectionner</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="datavalue.etatline === 2 && datavalue.linemessage" class="cf-card-error"><span v-html="datavalue.linemessage"></span></div>
                                        </div>
                                    </template>
                                    <div v-else class="empty-state">
                                        <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                                        <p class="empty-state__title">Aucun article ajouté</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- ========== FOOTER ========== -->
                    <div class="cf-dialog-foot cf-dialog-foot--split">
                        <div class="cf-foot-info">
                            <span v-if="listedatatable.length">{{ listedatatable.length }} article(s) ajouté(s)</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                            <button v-if="!isdisplayviewarticle && typeaction === 'add'" @click="saveItems" class="ti-btn ti-btn-success-full">Valider</button>
                            <button v-if="!isdisplayviewarticle && typeaction === 'update'" @click="updateItems" class="ti-btn ti-btn-primary-full">Modifier</button>
                            <button v-if="isdisplayviewarticle" @click="close" class="ti-btn ti-btn-success-full">Appliquer</button>
                        </div>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <!-- Child Components -->
    <modallistedesarticles refreshable @actualiser="actualiserCatalogue" @elementSelectionnearticle="handleElementSelectedarticle" ref="modallistedesarticles" />
</template>

<script>
    import { cloneobjet, randomString, currencyFormatDE, FormatNumber } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import { lireCatalogueCache, ecrireCatalogueCache } from "@/service/catalogueArticlesCache";
    import modallistedesarticles from "@/components/views/pages/stock/mvtstock/modal_listedesarticles";
    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "EnhancedDocumentFormModal",

        components: {
            modallistedesarticles
        },

        data() {
            return {
                isdisplayviewarticle: false,
                isdisplay: false,
                messageerror: "",
                messagesucces: "",
                titlemodal: "",
                typedoc: "",
                typeaction: "add",
                Items: this.createEmptyDocument(),
                alldata: [],
                listedatatable: [],
                listedatatableproduit: [],
                mydocmag: '',
                ItemsArticle: this.createEmptyArticle(),
                disabled: false,
                isLoading: false,
                isLoadingCatalogue: false
            };
        },

        computed: {
            listeversmagasins() {
                if (this.Items.mag !== null) {
                    return this.returnGetAllmagasin.filter(m => m.pid !== this.Items.mag.pid);
                }
                return [];
            },

            disableddoc() {
                return !!this.Items.docnum;
            },

            stock() {
                return this.ItemsArticle.article !== null
                    ? parseFloat(this.ItemsArticle.article.rstck)
                    : 0;
            },

            returnGetAllmagasin() {
                if (!this.$store.state.annexeuser || this.$store.state.annexeuser.length === 0) {
                    return this.alldata.magasin || [];
                }
                return this.$store.state.annexeuser;
            }
        },

        methods: {
            // ============ INITIALIZATION ============
            createEmptyDocument() {
                return {
                    pid: '',
                    mag: null,
                    datedoc: '',
                    docobservation: '',
                    docnum: '',
                    docnumother: '',
                    docpid: 0,
                    doctyp: '',
                    infodoc: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
                    jsonotherdonne: {
                        datedelivraison: '',
                        dateechancefacture: '',
                        tpdoc: '',
                        tredocument: '',
                        magvers: null,
                        mtypprixdevente: 'prixvente',
                        collaborateur: null,
                        cltfrs: null,
                        moderglt: null,
                        cdtreglement: null,
                        appliquetva: 1,
                        aib: 0,
                        adresseexpedition: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
                        infodoc: {
                            infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '',
                            infolibre4: '', infolibre5: '', infolibre6: '', infolibre7: '',
                            infolibre8: '', infolibre9: '', infolibre10: '', infolibre11: '',
                        },
                        piedsinfodoc: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
                    },
                    mtnt: {
                        docmtntaib: '0', docmtntremise: '0', docmtnttotalht: '0',
                        docmtnttotalttc: '0', doctva: '0', doccalmtnttotalht: '0', libaib: 'AIB',
                    },
                    params: { param1: null, param2: null, param3: null, param4: null },
                    jsondoc: {},
                };
            },

            createEmptyArticle() {
                return {
                    autredesignation: '',
                    docnum: '',
                    article: null,
                    qtite: 0,
                    diqte: 0,
                    pu: 0,
                    pa: 0,
                    mtnt: 0,
                    mtntclt: 0,
                    remise: 0,
                    doc: '',
                    docpid: '',
                    docnumother: '',
                    docmag: '',
                    doctp: '',
                    linekey: '',
                    etatline: 0,
                    pid: '',
                    spid: ''
                };
            },

            // ============ MODAL METHODS ============
            show(titlemodal, typeaction, typedoc, Items, alldata) {
                this.titlemodal = titlemodal;
                this.typeaction = typeaction;
                this.typedoc = typedoc;
                this.Items = Items;
                this.alldata = alldata;
                this.clearMessages();
                this.isdisplayviewarticle = false;
                this.isdisplay = true;
                document.body.style.overflow = 'hidden';
            },

            async showupdate(titlemodal, typeaction, typedoc, Items, alldata) {
                this.show(titlemodal, typeaction, typedoc, Items, alldata);
                this.ItemsArticle = this.createEmptyArticle();

                if (Items.pid) {
                    this.isdisplayviewarticle = true;
                    await this.loadDocumentDetails(Items);
                }
            },

            close() {
                this.listedatatableproduit = [];
                this.listedatatable = [];
                this.ItemsArticle = this.createEmptyArticle();
                this.isdisplayviewarticle = false;
                this.isdisplay = false;
                document.body.style.overflow = '';
                this.$emit('closed');
            },

            // ============ CACHE CATALOGUE (IndexedDB, par société + magasin, voir service/catalogueArticlesCache) ============
            lireCatalogueCache(pidmag) {
                return lireCatalogueCache(this.$store.state.appsociete, pidmag);
            },

            ecrireCatalogueCache(pidmag, liste) {
                return ecrireCatalogueCache(this.$store.state.appsociete, pidmag, liste);
            },

            // Télécharge la liste d'articles du magasin du document (route de réouverture, action "upd")
            // et la range dans le cache du poste. Lève une erreur si la liste n'est pas reçue.
            async telechargerCatalogue(pidmag) {
                const piddoc = this.Items.docpid || this.Items.pid;
                const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/${this.Items.docnum}/${piddoc}/upd/${this.$store.state.appsociete}/${randomString()}`;

                const response = await axios.get(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${JwtService.getToken()}`,
                        'csrftoken': this.$store.state.appsociete,
                    },
                    withCredentials: true,
                });

                if (!response.data.success || !Array.isArray(response.data.m)) {
                    throw new Error('Liste non reçue');
                }

                await this.ecrireCatalogueCache(pidmag, response.data.m);
                return response.data.m;
            },

            // Après la validation de l'en-tête : liste lue dans le cache du poste, sinon téléchargée en arrière-plan
            async chargerCatalogue() {
                const pidmag = this.mydocmag;
                this.isLoadingCatalogue = true;

                try {
                    let liste = await this.lireCatalogueCache(pidmag);
                    if (liste.length === 0) {
                        liste = await this.telechargerCatalogue(pidmag);
                    }
                    // Le document a pu être fermé ou changé pendant le chargement
                    if (this.isdisplay && this.mydocmag === pidmag) {
                        this.listedatatableproduit = liste;
                    }
                } catch (error) {
                    console.error('Error loading catalogue:', error);
                    this.showError("La liste des articles n'a pas pu être chargée. Ouvrez « Rechercher » puis cliquez sur « Actualiser ».");
                } finally {
                    this.isLoadingCatalogue = false;
                }
            },

            // Bouton « Actualiser » de la fenêtre de recherche : recharge la liste depuis le serveur
            async actualiserCatalogue() {
                const modal = this.$refs.modallistedesarticles;

                try {
                    this.listedatatableproduit = await this.telechargerCatalogue(this.mydocmag);
                    modal.finActualisation(this.listedatatableproduit);
                } catch (error) {
                    console.error('Error refreshing catalogue:', error);
                    modal.finActualisation(null, "Impossible d'actualiser la liste des articles. Vérifiez la connexion puis réessayez.");
                }
            },

            // ============ DATA LOADING ============
            async loadDocumentDetails(items) {
                this.isLoading = true;

                try {
                    // Liste déjà en cache sur le poste : on ne la redemande pas au serveur (action autre que "upd")
                    const pidmagcache = items.mag?.pid || '';
                    const catalogue = await this.lireCatalogueCache(pidmagcache);
                    const btnaction = catalogue.length > 0 ? 'cache' : 'upd';

                    const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/${items.numdoc}/${items.pid}/${btnaction}/${this.$store.state.appsociete}/${randomString()}`;

                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        if (catalogue.length > 0) {
                            this.listedatatableproduit = catalogue;
                        } else {
                            this.listedatatableproduit = response.data.m || [];
                            this.ecrireCatalogueCache(pidmagcache, this.listedatatableproduit);
                        }
                        this.listedatatable = response.data.alllignedoc || [];

                        // Update Items
                        this.Items.jsonotherdonne = items.jsonotherdonne;
                        this.Items.mag = items.mag;
                        this.Items.pid = items.pid;
                        this.ItemsArticle.docpid = items.pid;
                        this.Items.params = items.params;
                        this.Items.mtnt = items.mtnt;
                        this.Items.docnum = items.numdoc;
                        this.Items.docnumother = items.docnumother;
                        this.Items.infodoc = items.infodoc;
                        this.Items.datedoc = items.datedoc;
                        this.Items.doctyp = items.doctyp;
                        this.Items.docobservation = items.observations;

                        // Update article context
                        this.mydocmag = items.mag?.pid || '';
                        this.ItemsArticle.docmag = this.mydocmag;
                        this.ItemsArticle.docnum = items.pid;
                        this.ItemsArticle.doctp = items.doctyp;
                        this.ItemsArticle.docnumother = items.docotherref;

                        this.showSuccess('Document chargé avec succès');
                    }
                } catch (error) {
                    this.showError('Erreur lors du chargement du document');
                    console.error('Error loading document details:', error);
                } finally {
                    this.isLoading = false;
                }
            },

            // ============ DOCUMENT SAVE/UPDATE ============
            async saveItems() {
                if (!this.validateDocument()) return;
                this.isLoading = true;

                try {
                    const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/sansvalidation/vadd/${this.typedoc}/${this.$store.state.appsociete}/${randomString()}`;

                    // sansliste : le serveur ne renvoie plus la liste d'articles avec l'en-tête
                    const response = await axios.post(url, { ...this.Items, sansliste: 1 }, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        this.mydocmag = this.Items.mag.pid;
                        this.ItemsArticle.docmag = this.mydocmag;
                        this.ItemsArticle.docnum = response.data.numdoc;
                        this.Items.docnum = response.data.numdoc;
                        this.Items.docpid = response.data.pid;
                        this.ItemsArticle.docpid = response.data.pid;

                        const listerecue = response.data.m || [];
                        if (listerecue.length > 0) {
                            // Serveur pas encore à jour : il a renvoyé la liste, on l'utilise
                            this.listedatatableproduit = listerecue;
                            this.ecrireCatalogueCache(this.mydocmag, listerecue);
                        } else {
                            this.listedatatableproduit = [];
                            this.chargerCatalogue();
                        }

                        this.newArticle();
                        this.showSuccess(response.data.message);
                        this.isdisplayviewarticle = true;
                    } else {
                        this.showError(this.formatErrorMessages(response.data));
                    }
                } catch (error) {
                    this.showError('Une erreur est survenue. Veuillez contacter votre administrateur.');
                } finally {
                    this.isLoading = false;
                }
            },

            async updateItems() {
                if (!this.validateDocument()) return;
                this.isLoading = true;

                try {
                    const url = `${process.env.VUE_APP_API_URL}/egl745874pdefinition771714dfe/tier/maj/${this.typedoc}/${this.$store.state.appsociete}/${randomString()}`;

                    const response = await axios.post(url, this.Items, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        this.showSuccess(response.data.message);
                        this.close();
                    } else {
                        this.showError(this.formatErrorMessages(response.data));
                    }
                } catch (error) {
                    this.showError('Une erreur est survenue. Veuillez contacter votre administrateur.');
                } finally {
                    this.isLoading = false;
                }
            },

            validateDocument() {
                const errors = [];

                if (!this.Items.mag) errors.push('Le magasin est requis');
                if (!this.Items.datedoc) errors.push('La date est requise');
                if (!this.Items.docobservation) errors.push('Le motif est requis');

                if (this.typedoc === 'mvt_transfert' && !this.Items.jsonotherdonne.magvers) {
                    errors.push('Le magasin destination est requis');
                }

                if (errors.length > 0) {
                    this.showError(errors.join(', '));
                    return false;
                }
                return true;
            },

            // ============ ARTICLE METHODS ============
            newArticle() {
                this.ItemsArticle = {
                    ...this.createEmptyArticle(),
                    docmag: this.mydocmag,
                    docnum: this.Items.docpid || this.Items.pid,
                    docpid: this.Items.docpid || this.Items.pid,
                    doctp: this.Items.doctyp,
                };
                this.disabled = false;
            },

            modifierArticle(value) {
                this.disabled = true;
                this.ItemsArticle = {
                    article: value.article,
                    qtite: value.qtite,
                    diqte: 0,
                    pu: value.pu,
                    pa: value.pa,
                    mtnt: value.mtnt,
                    docnumother: value.docnumother,
                    remise: value.remise,
                    doctp: value.doctyp,
                    pid: value.pid,
                    linekey: value.linekey,
                    etatline: value.etatline,
                    docpid: value.docnum,
                    docnum: value.docnum,
                    docmag: this.mydocmag,
                    spid: ''
                };
            },

            async SaveArticle() {
                if (!this.validateArticle()) return;

                const isNew = !this.ItemsArticle.linekey;
                const linekey = this.ItemsArticle.linekey || randomString(8);

                this.ItemsArticle.linekey = linekey;
                this.ItemsArticle.etatline = 0;
                const articleData = cloneobjet(this.ItemsArticle);

                if (isNew) {
                    this.listedatatable.push(articleData);
                } else {
                    const index = this.listedatatable.findIndex(l => l.linekey === linekey);
                    if (index !== -1) {
                        this.listedatatable[index] = { ...this.listedatatable[index], ...articleData };
                    }
                }

                this.newArticle();
                this.isLoading = true;

                try {
                    const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/sansvalidation/vline/${this.typedoc}/${this.$store.state.appsociete}/${randomString()}`;

                    const response = await axios.post(url, articleData, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        this.updateLineStatus(linekey, 1, response.data.key);
                        this.showSuccess(response.data.message);
                    } else {
                        this.updateLineStatus(linekey, 2, null, response.data.message);
                        this.showError(response.data.message);
                    }
                } catch (error) {
                    this.updateLineStatus(linekey, 2, null, 'Erreur lors du traitement');
                    this.showError('Une erreur est survenue');
                } finally {
                    this.isLoading = false;
                }
            },

            async deleteItemArticle() {
                if (!this.validateArticleForDeletion()) return;
                if (!this.ItemsArticle.linekey) return;

                const linekey = this.ItemsArticle.linekey;

                // If not saved to database yet
                if (!this.ItemsArticle.pid) {
                    this.listedatatable = this.listedatatable.filter(l => l.linekey !== linekey);
                    this.newArticle();
                    return;
                }

                this.ItemsArticle.spid = this.ItemsArticle.docnum;
                const articleData = cloneobjet(this.ItemsArticle);

                this.newArticle();
                this.isLoading = true;

                try {
                    const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/sansvalidation/vline/${this.typedoc}/${this.$store.state.appsociete}/${randomString()}`;

                    const response = await axios.post(url, articleData, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        this.listedatatable = this.listedatatable.filter(l => l.linekey !== linekey);
                        this.showSuccess(response.data.message);
                    } else {
                        this.updateLineStatus(linekey, 2, null, response.data.message);
                        this.showError(response.data.message);
                    }
                } catch (error) {
                    this.updateLineStatus(linekey, 2, null, 'Erreur lors de la suppression');
                    this.showError('Une erreur est survenue');
                } finally {
                    this.isLoading = false;
                }
            },

            validateArticle() {
                if (!this.ItemsArticle.article) {
                    this.showError('Veuillez sélectionner un article');
                    return false;
                }
                /*if (!this.ItemsArticle.qtite || this.ItemsArticle.qtite <= 0) {
                    this.showError('Veuillez saisir une quantité valide');
                    return false;
                }*/
                return true;
            },

            validateArticleForDeletion() {
                if (!this.ItemsArticle.article) {
                    this.showError('Veuillez sélectionner un article');
                    return false;
                }
                return true;
            },

            updateLineStatus(linekey, status, pid = null, message = null) {
                const line = this.listedatatable.find(l => l.linekey === linekey);
                if (line) {
                    line.etatline = status;
                    if (pid && !line.pid) line.pid = pid;
                    if (message) line.linemessage = message;
                }
            },

            // ============ PRICE MANAGEMENT ============
            gestionPu() {
                if (!this.ItemsArticle.article) return;

                const article = this.ItemsArticle.article;

                if (parseInt(this.Items.jsonotherdonne.appliquetva) === 1) {
                    if (parseInt(article.tptva) === 1) {
                        if (parseInt(article.typeprixvente) === 1) {
                            const cal = parseInt(article.pa) / 1.18;
                            this.ItemsArticle.pa = Math.round(cal);
                            this.ItemsArticle.pu = article.pu;
                        } else {
                            const cal = parseInt(article.pa) * 0.18;
                            this.ItemsArticle.pa = article.pa;
                            this.ItemsArticle.pu = Math.round(cal);
                        }
                    } else {
                        this.ItemsArticle.pa = article.pa;
                        this.ItemsArticle.pu = article.pu;
                    }
                } else {
                    this.ItemsArticle.pa = article.pa;
                    this.ItemsArticle.pu = article.pu;
                }
            },

            // ============ MODAL OPENERS ============
            btnmodallistedesarticles(option) {
                this.$refs.modallistedesarticles.show(
                    'Liste des articles',
                    option,
                    this.listedatatableproduit
                );
            },

            handleElementSelectedarticle(elementSelectionne) {
                this.ItemsArticle.article = elementSelectionne.value;
                this.changeItem(this.ItemsArticle.article);
            },

            changeItem(value) {
                if (!value || this.ItemsArticle.pid) return;

                const exists = this.listedatatable.some(
                    article => article.article?.pid === value.pid
                );

                if (exists) {
                    this.showError(`${value.libelle} existe déjà dans la liste`);
                    this.ItemsArticle.article = null;
                    this.ItemsArticle.qtite = 0;
                } else {
                    this.gestionPu();
                }
            },

            // ============ UTILITIES ============
            formatCurrency(value) {
                return currencyFormatDE(Number(value) || 0);
            },

            formatNumber(value) {
                return FormatNumber(Number(value) || 0);
            },

            formatErrorMessages(data) {
                if (data.datamessage?.length > 0) {
                    return data.datamessage.join(', ');
                }
                return data.message || 'Une erreur est survenue';
            },

            getStatusClass(status) {
                const classes = {
                    0: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
                    1: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
                    2: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
                };
                return classes[status] || classes[0];
            },

            getStatusDotClass(status) {
                const classes = {
                    0: 'bg-blue-500',
                    1: 'bg-green-500',
                    2: 'bg-red-500',
                };
                return classes[status] || classes[0];
            },

            getStatusLabel(status) {
                const labels = {
                    0: 'En attente',
                    1: 'OK',
                    2: 'Erreur',
                    4: 'Erreur'
                };
                return labels[status] || 'En attente';
            },

            showSuccess(message) {
                this.messagesucces = message;
                this.messageerror = '';
                setTimeout(() => { this.messagesucces = ''; }, 5000);
            },

            showError(message) {
                this.messageerror = message;
                this.messagesucces = '';
                setTimeout(() => { this.messageerror = ''; }, 5000);
            },

            clearMessages() {
                this.messagesucces = '';
                this.messageerror = '';
            },
        },

        beforeUnmount() {
            document.body.style.overflow = '';
        },
    };
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; }
.cf-foot-info { font-size:0.8rem; color:var(--cf-muted); font-weight:500; }

/* Alertes */
.cf-alert-zone { padding:0.85rem 1.25rem 0; flex-shrink:0; }
.cf-alert { display:flex; align-items:center; gap:0.6rem; padding:0.7rem 0.9rem; border-radius:var(--cf-radius-sm); font-size:0.82rem; border:1px solid; }
.cf-alert i { font-size:1.1rem; flex-shrink:0; }
.cf-alert--success { background:#ecfdf5; border-color:#a7f3d0; color:#047857; }
.cf-alert--danger { background:#fef2f2; border-color:#fecaca; color:#b91c1c; }

/* Bandeau info */
.cf-info-banner { display:flex; align-items:center; gap:0.6rem; padding:0.7rem 0.9rem; border-radius:var(--cf-radius-sm); background:rgb(var(--primary) / 0.06); border:1px solid rgb(var(--primary) / 0.18); color:rgb(var(--primary)); font-size:0.82rem; font-weight:500; }

/* Champs */
.cf-field-label { display:block; font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); margin-bottom:6px; }
.cf-req { color:rgb(var(--danger)); }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-inp--readonly { background:var(--cf-surface-alt); color:var(--cf-muted); cursor:not-allowed; }
.cf-textarea { height:auto; padding:10px 12px; resize:vertical; line-height:1.5; }
.cf-select-wrap { position:relative; }
.cf-select { appearance:none; padding-right:28px; cursor:pointer; }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }

/* Sous-panneau formulaire article */
.cf-subpanel { padding:1rem; border-radius:var(--cf-radius-sm); background:var(--cf-surface); border:1px solid var(--cf-border); }
.cf-subpanel-actions { border-top:1px solid var(--cf-border); }

/* Table */
.cf-table-wrap { overflow:auto; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); }
.cf-table { width:100%; border-collapse:collapse; font-size:0.82rem; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.th--right { text-align:right; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; }
.td--center { text-align:center; }
.td--right { text-align:right; }
.row-number { color:var(--cf-faint); font-size:0.75rem; font-variant-numeric:tabular-nums; }
.cf-line-error { background:#fef2f2; color:#b91c1c; font-size:0.78rem; }

/* Badge de statut (couleurs fournies par getStatusClass/getStatusDotClass) */
.cf-badge { display:inline-flex; align-items:center; gap:5px; padding:2px 9px; font-size:0.72rem; font-weight:600; border-radius:999px; }
.cf-badge-dot { width:6px; height:6px; border-radius:999px; }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }
.empty-state__sub { font-size:0.8rem; color:var(--cf-muted); margin:4px 0 0; }

/* Cartes mobile */
.cf-card { border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); overflow:hidden; background:#fff; }
.cf-card-head { display:flex; align-items:center; justify-content:space-between; padding:0.6rem 0.85rem; background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); }
.cf-card-index { font-size:0.8rem; font-weight:600; color:var(--cf-ink-strong); }
.cf-card-body { padding:0.85rem; }
.cf-card-title { font-weight:600; color:var(--cf-ink-strong); margin:0 0 0.6rem; }
.cf-card-lbl { font-size:0.72rem; color:var(--cf-muted); margin:0; }
.cf-card-val { font-size:0.85rem; font-weight:600; color:var(--cf-ink); margin:2px 0 0; }
.cf-card-link { background:none; border:none; color:rgb(var(--primary)); font-size:0.82rem; font-weight:600; cursor:pointer; }
.cf-card-error { padding:0.5rem 0.85rem; background:#fef2f2; color:#b91c1c; font-size:0.78rem; border-top:1px solid #fecaca; }

/* Transitions */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

.cf-dialog-body::-webkit-scrollbar, .cf-table-wrap::-webkit-scrollbar { width:6px; height:6px; }
.cf-dialog-body::-webkit-scrollbar-thumb, .cf-table-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } .cf-dialog { max-height:96vh; } }
</style>
